export var CardPendingEvent;
(function (CardPendingEvent) {
    /**
     * Pending secure cardholder authentication.
     *
     * @note EMVCo 1.3 replaces this with `PENDING_CARDHOLDER_AUTHENTICATION`, but
     * precheckout continues to send it only as `PENDING_SCA`.
     */
    CardPendingEvent["PENDING_SCA"] = "PENDING_SCA";
    /** Pending secure cardholder authentication. */
    CardPendingEvent["PENDING_CARDHOLDER_AUTHENTICATION"] = "PENDING_CARDHOLDER_AUTHENTICATION";
    /** Pending address verification service. */
    CardPendingEvent["PENDING_AVS"] = "PENDING_AVS";
    /** Pending cardholder secure code verification (CVC). */
    CardPendingEvent["PENDING_CSC"] = "PENDING_CSC";
    /** Pending consumer identity verification. */
    CardPendingEvent["PENDING_CONSUMER_IDV"] = "PENDING_CONSUMER_IDV";
    /** Pending provision digitization. Non-EMVCo standard. */
    CardPendingEvent["PENDING_PROVISION"] = "PENDING_PROVISION";
    /** Pending card tokenization. */
    CardPendingEvent["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
})(CardPendingEvent || (CardPendingEvent = {}));
//# sourceMappingURL=CardPendingEvent.js.map